export default function () {
  const closure = () => {
    let timeouter;
    return (func, timeout) => {
      clearTimeout(timeouter);
      timeouter = setTimeout(() => {
        func();
      }, timeout);
    };
  };
  return closure();
}
